import {
  CONFIRMED_GET_MEDICINE_STARTED,
  CONFIRMED_GET_PRESCRIPTION_EXPLAINED,
  CONFIRMED_GET_SERVICE_CALLER_SUMMARY,
  CONFIRMED_ADD_REMINDER,
  CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST,
  CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS,
  CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE,
  GET_SCHEDULED_LIST,
  GET_ANSWER_LIST_REQUEST,
  GET_ANSWER_LIST_SUCCESS,
  GET_ANSWER_LIST_FAILURE,
  GENERATE_FOLLOWUP_ID_REQUEST,
  GENERATE_FOLLOWUP_ID_SUCCESS,
  GENERATE_FOLLOWUP_ID_FAILURE,
  ADD_FOLLOWUP_REQUEST,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_FAILURE,
  GET_FOLLOWUP_LIST_REQUEST,
  GET_FOLLOWUP_LIST_SUCCESS,
  GET_FOLLOWUP_LIST_FAILURE,
  ADD_NOTE_REQUEST,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_FAILURE,
  RESET_NOTES,
} from "../types/ServiceFollowUpTypes";

const initialState = {
  medicineStartedData: {},
  prescriptionExplainedData: {},
  prescriptionSummaryData: {},
  addReminderData: {},
  scheduledListData: {},
  followUpDelayData: {},
  loading: false,
  answerList: [],
  followupIdData: null,
  followupIdLoading: false,
  followupIdError: null,
  addFollowupData: null,
  addFollowupLoading: false,
  addFollowupError: null,
  followupListData: [],
  followupListLoading: false,
  followupListError: null,
  notes: [],
  addNoteLoading: false,
  addNoteError: null,

  error: null,
};

export default function ServiceFollowUpReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ANSWER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ANSWER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        answerList: action.payload,
        error: null,
      };

    case GET_ANSWER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONFIRMED_GET_SERVICE_CALLER_SUMMARY:
      return {
        ...state,
        prescriptionSummaryData: action.payload,
        loading: false,
        error: null,
      };

    case CONFIRMED_ADD_REMINDER:
      return {
        ...state,
        addReminderData: action.payload.data || {},
        loading: false,
        error: action.payload.error || null,
      };
    case CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS:
      return {
        ...state,
        followUpDelayData: action.payload.data || {},
        loading: false,
        error: null,
      };

    case CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || null,
      };

    case GET_SCHEDULED_LIST:
      return {
        ...state,
        scheduledListData: action.payload.data || {},
        loading: false,
        error: action.payload.error || null,
      };

    case GENERATE_FOLLOWUP_ID_REQUEST:
      return {
        ...state,
        followupIdLoading: true,
        followupIdError: null,
      };
    case GENERATE_FOLLOWUP_ID_SUCCESS:
      return {
        ...state,
        followupIdLoading: false,
        followupIdData: action.payload,
      };
    case GENERATE_FOLLOWUP_ID_FAILURE:
      return {
        ...state,
        followupIdLoading: false,
        followupIdError: action.payload,
      };

    case ADD_FOLLOWUP_REQUEST:
      return {
        ...state,
        addFollowupLoading: true,
        addFollowupError: null,
      };
    case ADD_FOLLOWUP_SUCCESS:
      return {
        ...state,
        addFollowupLoading: false,
        addFollowupData: action.payload,
      };
    case ADD_FOLLOWUP_FAILURE:
      return {
        ...state,
        addFollowupLoading: false,
        addFollowupError: action.payload,
      };

    case GET_FOLLOWUP_LIST_REQUEST:
      return {
        ...state,
        followupListLoading: true,
        followupListError: null,
      };
    case GET_FOLLOWUP_LIST_SUCCESS:
      return {
        ...state,
        followupListLoading: false,
        followupListData: action.payload,
        followupListError: null,
      };
    case GET_FOLLOWUP_LIST_FAILURE:
      return {
        ...state,
        followupListLoading: false,
        followupListError: action.payload,
      };

    case ADD_NOTE_REQUEST:
      return {
        ...state,
        addNoteLoading: true,
        addNoteError: null,
      };

    case ADD_NOTE_SUCCESS:
      const newNote = {
        ...action.payload,
        created_at: action.payload.created_at
          ? new Date(action.payload.created_at).toLocaleDateString()
          : new Date().toLocaleDateString(),
      };
      return {
        ...state,
        addNoteLoading: false,
        notes: [...state.notes, newNote],
      };

    case ADD_NOTE_FAILURE:
      return {
        ...state,
        addNoteLoading: false,
        addNoteError: action.payload,
      };

    case RESET_NOTES:
      return {
        ...state,
        notes: [],
        addNoteLoading: false,
        addNoteError: null,
      };

    default:
      return state;
  }
}
